import styles from './page.module.scss';
import React, {CSSProperties} from 'react';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    children: React.ReactNode;
    wide?: boolean;
    style?: CSSProperties;
}

export function PageContent({children, wide, style}: OwnProps) {
    return (
        <div
            style={style}
            className={classNames(styles.page__content, {
                [styles.wide]: wide,
            })}
        >
            {children}
        </div>
    );
}
